module.exports = __webpack_public_path__ + "media/images/logo-5d2f91ff83581b21896a3bc4b674841b.png";